import { ScreenshareSourceDetails } from 'features/layout/types';
import { RoomJoinedPayload } from 'features/room/types';
import { ContentData } from 'features/layout/features/content/types';
import { UserId } from 'features/users/types';
import { AvailableScreenshares } from 'utils/webrtc/ReceivingFeed';
import {
  ContentProcessingResult,
  createProcessingState,
  trackLatestAndLocked,
} from './contentProcessing';

export type ProcessedScreenshares = ContentProcessingResult<
  ScreenshareSourceDetails[],
  ScreenshareSourceDetails
> & {
  availableScreenshares: AvailableScreenshares;
};

export function processScreensharesForRoom(
  users: RoomJoinedPayload['users'],
  lockedContent: ContentData | null,
  localUserId: UserId
): ProcessedScreenshares {
  const screenshares: ScreenshareSourceDetails[] = [];
  const state = createProcessingState<ScreenshareSourceDetails>();
  const availableScreenshares: AvailableScreenshares = {};

  const lockedId = lockedContent?.type === 'screenshare' ? lockedContent.id : null;

  for (const user of users) {
    if (
      user.screensharing &&
      user.screenshareFeedId &&
      user.screenshareStreams?.length &&
      user.startScreenshareTimestamp
    ) {
      const timestamp = user.pushedScreenshareTimestamp || user.startScreenshareTimestamp;
      const screenshare: ScreenshareSourceDetails = {
        kind: `screenshare-${user.id === localUserId ? 'local' : 'remote'}`,
        userId: user.id,
        feedId: user.screenshareFeedId,
        timestamp,
      };

      availableScreenshares[user.screenshareFeedId] = user.screenshareStreams;

      screenshares.push(screenshare);
      trackLatestAndLocked(screenshare, user.screenshareFeedId, timestamp, lockedId, state);
    }
  }

  return {
    collection: screenshares,
    availableScreenshares,
    ...state,
  };
}
